import React ,{useEffect, useState}from 'react';
import { useForm, Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Modal from 'react-modal'
import toast from 'react-hot-toast'
import  {sendSMSMiseADispo,verifyCodeSMSMiseADispo,updateRecipientInfo,softDeleteWaypoint} from '../../api/commande'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router';
import moment from "moment"
import { convertMinutesToHHMM,isValidTimeFormat } from '../../utils/formatters';
import { Truck, ChevronDown, ChevronUp, Trash2,ArrowUpDown, Mail, Phone, AlertTriangle } from 'lucide-react';
import ActionModal from '../ValidationModal/ActionModal'
import { useTranslation } from 'react-i18next';

const styles = {
    container: {
      width: '100%',
      padding: '1.5rem',
      borderRadius: '12px',
      marginBottom: '1rem',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      position: 'relative',
      fontFamily: 'Montserrat',
    },
    depotBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      backgroundColor: '#E0F2FE',
      color: '#0369A1',
      padding: '4px 8px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: '500',
      marginLeft: '10px'
    },
    actionButtons: {
      position: 'absolute',
      top: '1rem',
      right: '1rem',
      display: 'flex',
      gap: '0.5rem'
    },
    iconButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      backgroundColor: '#F3F4F6',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      border: 'none',
      padding: 0,
      '&:hover': {
        backgroundColor: '#E5E7EB'
      }
    },
    infoGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '1.5rem',
      marginBottom: '1.5rem'
    },
    infoItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.25rem'
    },
    label: {
      color: '#6B7280',
      fontSize: '0.875rem'
    },
    value: {
      color: '#dc2626',
      fontWeight: '500'
    },
    form: {
      marginTop: '1.5rem'
    },
    formGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '1.5rem',
      marginBottom: '1.5rem'
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    },
    input: {
      padding: '0.75rem',
      borderRadius: '0.5rem',
      border: '1px solid #E5E7EB',
      width: '100%',
      fontFamily: 'Montserrat',
      transition: 'all 0.2s ease'
    },
    error: {
      color: "#EF4444",
      fontSize: '0.875rem'
    },
    buttonGroup: {
      display: 'flex',
      gap: '1rem',
      marginBottom: '1.5rem',
      flexWrap: 'wrap'
    },
    button: {
      padding: '0.75rem 1.5rem',
      borderRadius: '0.5rem',
      border: 'none',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
      minWidth: '150px',
      height: '50px',
      fontFamily: 'Montserrat'
    },
    primaryButton: {
      backgroundColor: "#60d2f8",
      color: 'white',
      '&:hover': {
        backgroundColor: "#4fa8c6"
      }
    },
    dangerButton: {
      backgroundColor: "#EF4444",
      color: 'white',
      '&:hover': {
        backgroundColor: "#DC2626"
      }
    },
    modalStyle: {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        maxWidth: '500px',
        width: '90%',
        padding: '2rem',
        borderRadius: '12px'
      }
    }
  };


const WaypointManagementCard = ({
    place,
    setChargement,
    commandeID,
    onReorder = () => {},
  }) => {
    const {  handleSubmit, control,register,watch, reset,formState: { errors } } = useForm();
    const history=useHistory()
    const [modalIsOpenSendSMS, setModalIsOpenSendSMS] = useState(false)
    const [modalIsOpenSendEmail, setModalIsOpenSendEmail] = useState(false)
    const [modalIsOpenDelete,setModalIsOpenDelete]=useState(false)
    const [loadingSendSMS,setLoadingSendSMS]=useState(false)
    const [loadingverifySMS,setLoadingverifySMS]=useState(false)
    const [enteredCode, setEnteredCode] = useState('');
    const [updateLoading,setUpdateLoading]=useState(false)
    const [loading,setLoading]=useState(false)
    const token = useSelector((state) => state.auth.token);
    const [isSigned,setIsSigned]=useState(place?.signé)
    const [collapsedItems, setCollapsedItems] = useState(false)
    const [selectedPlace,setSelectedPlace]=useState(null)
    const {t} = useTranslation();
    const onSubmit = async (data,placeId) => {
        setUpdateLoading(true);
        try {
            let updatedata = {
                nom_destinataire: data.nom_destinataire,
                prénom_destinataire: data.prénom_destinataire,
                téléphone_destinataire: data.téléphone_destinataire,
                ...(data.email_destinataire && { email_destinataire: data.email_destinataire }),
                ...(data.nom_entreprise && { nom_entreprise: data.nom_entreprise })
            };
            
            
            await updateRecipientInfo(placeId,updatedata,token)
            toast.success(t("recipient_information_saved"), {
                    style: {
                        fontFamily: 'Montserrat',
                    },
                });
            setChargement(true)

        } catch (error) {
            toast.error(t("transfer_request_err"), {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setUpdateLoading(false);
            
        }
    };
    useEffect(()=>{
     
    reset(place)
    },[place])
const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
    return (
        <div style={{
            ...styles.container,
            backgroundColor: isSigned ? '#E6F7FF' : '#F5F7FA'
          }}>
            {!place.depot && (
              <div 
             style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '16px',
            marginBottom: '1.5rem'
        }}
    >
        <button
            onClick={() => setCollapsedItems(!collapsedItems)}
            style={{
             display: 'flex',
             alignItems: 'center',
             gap: '0.5rem',
            color: '#4b5563', 
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'color 0.2s ease-in-out',
            background: 'none',
            border: 'none'

            }}
        >
            {collapsedItems ? (
                <>
                    <span>{t("collapse")}</span>
                    <ChevronUp style={{ width: '1.25rem', height: '1.25rem' }}/>
                </>
            ) : (
                <>
                    <span>{t("expand")}</span>
                    <ChevronDown style={{ width: '1.25rem', height: '1.25rem' }}/>
                </>
            )}
        </button>
        
        {!isSigned && (
            <>
            <button
                onClick={()=>{
                    console.log("1")
                    onReorder()
                }}
                style={{
                    color: '#51C7F2',
                    transition: 'color 0.15s ease-in-out',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                }}
            >
                <ArrowUpDown style={{ width: '1.25rem', height: '1.25rem' }}/>
            </button>
            <button
                onClick={() => {
                    setSelectedPlace(place?._id);
                    setModalIsOpenDelete(true);
                }}
                style={{
                    color: '#ef4444',
                    transition: 'color 0.15s ease-in-out',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                }}
            >
                <Trash2 style={{ width: '1.25rem', height: '1.25rem' }}/>
            </button>
            
            </>
        )}
              </div>
            )}
            
            <div 
            style={{
                 display: 'flex', 
                 flexDirection : isSmallScreen? 'column' : 'row',
                 justifyContent: 'space-between', 
                 alignItems:isSmallScreen? 'flex-start' : 'center', 
                 
            }}>  
             <div style={{
                 fontSize: '14px',
                 color: '#4A5568',
                 marginBottom: '8px',
                 lineHeight: '1.5',
                 display :'flex',
                 flexDirection : isSmallScreen? 'column' : 'row'
             }}>
                <span><strong>{t("address")} :</strong>{' '}
                <span style={{ color: '#FF5A5F',fontWeight: '600'}}>{place.adresse.label}</span></span>
                <span><strong style={{ marginLeft: isSmallScreen ? 0 : "1rem" }}>Distance :</strong>{' '}
                <span style={{ color: '#FF5A5F',fontWeight: '600'}}>{place.distance} Km</span></span>
                <span><strong style={{ marginLeft: isSmallScreen ? 0 : "1rem"}}>{t("duration")} :</strong>{' '}
                <span style={{ color: '#FF5A5F',fontWeight: '600'}}>
                   {place?.heure && isValidTimeFormat(place.heure) ? place.heure : convertMinutesToHHMM(place?.heure || 0)}
                </span></span>
                {place?.signé && place?.date_signature && (
                    <>
                        <span><strong style={{ marginLeft: isSmallScreen ? 0 : "1rem"}}>{t("date_of_signature")} :</strong>{' '}
                        <span style={{ color: '#FF5A5F',fontWeight: '600'}}>
                        {moment(place.date_signature).format('DD/MM/YYYY HH:mm')}
                        </span></span>
                    </>
                   )}
             </div>
              {place.depot && (
                <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    backgroundColor: '#E0F2FE',
                    color: '#0369A1',
                    padding: '4px 8px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '500',
                    marginLeft:isSmallScreen?0: '10px', 
                }}>
                 <Truck size={16} />
                 {t("drop_off_point")}
                 </span>
                )} 
            </div>

          
            {(!place.depot && collapsedItems) && (
                <form onSubmit={handleSubmit((data) => onSubmit(data, place._id))} 
                style={{
                    marginTop: '1.5rem'
                }}>
                    <div style={{
                          display: 'grid',
                          gridTemplateColumns: isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',
                          gap: '1.5rem',
                          marginBottom: '1.5rem'
                    }}>
                        <div style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.5rem'
                        }}>
                            <label  
                            style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                            }}>{t("nom_destinataire")}</label>
                            <Controller
                                name="nom_destinataire"
                                control={control}
                                rules={{ required: t("nom_destinataire_err") }}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        disabled={isSigned}
                                        type="text"
                                        style={{
                                            padding: '0.75rem',
                                            borderRadius: '0.5rem',
                                            border: '1px solid #E5E7EB',
                                            width: '100%',
                                            fontFamily: 'Montserrat',
                                            transition: 'all 0.2s ease',
                                        }}
                                    />
                                )}
                            />
                            {errors?.nom_destinataire && (
                                <span 
                                style={{
                                    color: "#EF4444",
                                    fontSize: '0.875rem'
                                }}>{errors.nom_destinataire.message}</span>
                            )}
                        </div>

                        <div 
                        style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.5rem'
                        }}>
                            <label 
                            style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                            }}>{t("prenom_destinataire")}</label>
                            <Controller
                                name="prénom_destinataire"
                                control={control}
                                rules={{ required: t("prenom_destinataire_err") }}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        disabled={isSigned}
                                        type="text"
                                        style={{
                                            padding: '0.75rem',
                                            borderRadius: '0.5rem',
                                            border: '1px solid #E5E7EB',
                                            width: '100%',
                                            fontFamily: 'Montserrat',
                                            transition: 'all 0.2s ease',
                                        }}
                                    />
                                )}
                            />
                            {errors?.prénom_destinataire && (
                                <span 
                                style={{
                                    color: "#EF4444",
                                    fontSize: '0.875rem'
                                }}>{errors.prénom_destinataire.message}</span>
                            )}
                        </div>

                        <div 
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem'
                        }}>
                            <label 
                            style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                            }}>{t("entreprise_name")}</label>
                            <Controller
                                name="nom_entreprise"
                                control={control}
                                rules={{
                                    minLength: {
                                        value: 2,
                                        message: t("company_name_err1")
                                    },
                                    maxLength: {
                                        value: 100,
                                        message: t("company_name_err2")
                                    }
                                }}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        disabled={isSigned}
                                        type="text"
                                        style={{
                                            padding: '0.75rem',
                                            borderRadius: '0.5rem',
                                            border: '1px solid #E5E7EB',
                                            width: '100%',
                                            fontFamily: 'Montserrat',
                                            transition: 'all 0.2s ease',
                                        }}
                                    />
                                )}
                            />
                            {errors?.nom_entreprise && (
                                <span 
                                style={{
                                    color: "#EF4444",
                                    fontSize: '0.875rem'
                                }}>{errors.nom_entreprise.message}</span>
                            )}
                        </div>

                        <div 
                        style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.5rem'
                        }}>
                            <label 
                            style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                            }}>{t("recipient_phone_number")}</label>
                            <Controller
                                name="téléphone_destinataire"
                                control={control}
                                rules={{ required: t("phone_number_err1") }}
                                render={({ field }) => (
                                    <PhoneInput
                                        {...field}
                                        country="fr"
                                        disabled={isSigned}
                                        inputStyle={{
                                            paddingRight: '1.5rem',
                                            paddingTop: '1.5rem',
                                            paddingBottom: '1.5rem',
                                            borderRadius: '0.5rem',
                                            border: 'none',
                                            fontFamily: 'Montserrat',
                                            color: '#858ea8',
                                            flex: '1',
                                            display: 'flex',
                                            width: '100%'
                                        }}
                                        buttonStyle={{
                                            borderRadius: '0.5rem',
                                            border: 'none',
                                            fontFamily: 'Montserrat',
                                            color: '#858ea8',
                                            flex: '1',
                                            display: 'flex'
                                        }}
                                       
                                    />
                                )}
                            />
                            {errors?.téléphone_destinataire && (
                                <span 
                                style={{
                                    color: "#EF4444",
                                    fontSize: '0.875rem'
                                }}>{errors.téléphone_destinataire.message}</span>
                            )}
                        </div>

                        <div 
                        style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.5rem'
                        }}>
                            <label 
                            style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                            }}>{t("email_destinataire")}</label>
                            <input
                                type="text"
                                style={{
                                    padding: '0.75rem',
                                    borderRadius: '0.5rem',
                                    border: '1px solid #E5E7EB',
                                    width: '100%',
                                    fontFamily: 'Montserrat',
                                    transition: 'all 0.2s ease',
                                }}
                                {...register('email_destinataire', {
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                        message: t("email_err_message")
                                    }
                                })}
                            />
                            {errors?.email_destinataire && (
                                <span style={{
                                    color: "#EF4444",
                                    fontSize: '0.875rem'
                                }}>{errors.email_destinataire.message}</span>
                            )}
                        </div>
                    </div>

                    {!isSigned && (
                        <div style={{
                            display: 'flex',
                            gap: '1rem',
                            marginBottom: '1.5rem',
                            flexWrap: 'wrap'
                        }}>
                            <button
                                type="submit"
                                disabled={updateLoading}
                                style={{
                                    padding: '0.75rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    border: 'none',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    minWidth: '150px',
                                    height: '50px',
                                    width : isSmallScreen ? '100%' : '' ,
                                    fontFamily: 'Montserrat',
                                    backgroundColor:"#60d2f8",
                                    color: 'white'
                                }}

                                >
                                {updateLoading ? <div className="loader"></div> : t("save")}
                            </button>

                            <button
                                type="button"
                                onClick={() => {
                                    if (!watch('téléphone_destinataire')) {
                                        toast.error(t("provide_phone_number"),{
                                            style: {
                                                fontFamily: 'Montserrat',
                                            },
                                        }
                                            
                                        );
                                        return;
                                    }
                                    setModalIsOpenSendSMS(true);
                                }}
                                style={{
                                    padding: '0.75rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    border: 'none',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    minWidth: '150px',
                                    width : isSmallScreen ? '100%' : '' ,
                                    height: '50px',
                                    fontFamily: 'Montserrat',
                                    backgroundColor:"#60d2f8",
                                    color: 'white'
                                }}
                            >
                                {t("send_code_by_sms")}
                            </button>

                            <button
                                type="button"
                                onClick={() => {
                                    if (!watch('email_destinataire')) {
                                        toast.error(t("provide_email"),{
                                            style: {
                                            fontFamily: 'Montserrat',
                                        },});
                                        return;
                                    }
                                    setModalIsOpenSendEmail(true);
                                }}
                                style={{
                                    padding: '0.75rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    border: 'none',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    minWidth: '150px',
                                    width : isSmallScreen ? '100%' : '' ,
                                    height: '50px',
                                    fontFamily: 'Montserrat',
                                    backgroundColor:"#60d2f8",
                                    color: 'white'
                                }}
                            >
                                {t("send_code_by_email")}
                            </button>
                        </div>
                    )}
                    {!isSigned &&
                    <div style={{
                          display: 'flex',
                          flexDirection : isSmallScreen ? 'column' : 'row',
                          gap: '1rem',
                          marginBottom: '1.5rem',
                          alignItems:isSmallScreen ? 'flex-start' : 'flex-end'
                    }}>
                        <div 
                        style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.5rem',
                              width : isSmallScreen ? '100%' : '' ,
                        }}>
                            <label  
                            style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                            }}>{t("verification_code")}</label>
                            <input
                                type="text"
                                value={enteredCode}
                                onChange={(e) => setEnteredCode(e.target.value)}
                                style={{
                                    padding: '0.75rem',
                                    borderRadius: '0.5rem',
                                    border: '1px solid #E5E7EB',
                                    width: '100%',
                                    fontFamily: 'Montserrat',
                                    transition: 'all 0.2s ease',
                                }}
                                placeholder={t("enter_received_code")}
                            />
                        </div>

                        <button
                            type="button"
                            disabled={loadingverifySMS}
                            onClick={async () => {
                                if (!enteredCode) {
                                    toast.error(t("verification_code_err"),
                                        {
                                            style: {
                                                fontFamily: 'Montserrat',
                                            },
                                        }
                                    );
                                    return;
                                }
                                setLoadingverifySMS(true);
                                try {
                                    const response = await verifyCodeSMSMiseADispo(
                                        { placeId: place._id, code: enteredCode },
                                        token
                                    );
                                    setEnteredCode('');
                                    toast.success(response.message,{style: {
                                        fontFamily: 'Montserrat',
                                    },});
                                    setChargement(true);
                                    if (response.success) {
                                        setIsSigned(true);
                                    }
                                } catch (error) {
                                    toast.error(t("transfer_request_err"),{
                                        style: {
                                            fontFamily: 'Montserrat',
                                        },
                                    });
                                } finally {
                                    setLoadingverifySMS(false);
                                }
                            }}
                            style={{
                                padding: '0.75rem 1.5rem',
                                borderRadius: '0.5rem',
                                border: 'none',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.5rem',
                                minWidth: '150px',
                                width : isSmallScreen ? '100%' : '' ,
                                height: '50px',
                                fontFamily: 'Montserrat',
                                backgroundColor: '#10B981',
                                color:'white' 
                            }}
                        >
                            {loadingverifySMS ? <div className="loader"></div> : t("validate_code")}
                        </button>
                    </div>
                    }
                    <div >
                        <span 
                        style={{
                                    color: '#374151',
                                    fontSize: '0.875rem',
                                    fontWeight: '500'
                        }}>{t("signed")}</span>
                        <div style={{
                              display: 'flex',
                              flexDirection : isSmallScreen? 'column' : 'row',
                              gap: isSmallScreen? '2rem' :'1rem',
                              marginTop: '0.5rem'
                        }}>
                            <div style={{display: 'flex', gap: '1rem'}}>
                            <button
                                type="button"
                                disabled={true}
                                style={{
                                    padding: '0.5rem 1.25rem',
                                    borderRadius: '5px',
                                    border: '1px solid #E5E7EB ',
                                    background: 'white',
                                    color: "#374151",
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    backgroundColor:isSigned ? '#fcc200':'',
                                    borderColor:isSigned ? '#fcc200' :'',
                                    color: isSigned ? 'white' :''
                                    
                                }}
                            >
                                {t("yes")}
                            </button>
                            <button
                                type="button"
                                disabled={true}
                                style={{
                                    padding: '0.5rem 1.25rem',
                                    borderRadius: '5px',
                                    border: '1px solid #E5E7EB ',
                                    background: 'white',
                                    color: "#374151",
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    backgroundColor:!isSigned ? '#fcc200':'',
                                    borderColor:!isSigned ? '#fcc200' :'',
                                    color: !isSigned ? 'white' :''
                                }}
                            >
                                {t("no")}
                            </button>
                            </div>
                            <button
                                type="button"
                                onClick={() => history.push(`/chauffeur/missions/${place._id}/${commandeID}/signaler`)}
                                style={{
                                    padding: '0.75rem 1.5rem',
                                    borderRadius: '0.5rem',
                                    border: 'none',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    minWidth: '150px',
                                    height: '50px',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: "#EF4444",
                                    color: "white",
                                }}
                            >
                                {t("report")}
                            </button>
                        </div>
                    </div>
                </form>
            )}

            <ActionModal
                isOpen={modalIsOpenSendSMS}
                onRequestClose={()=>{}}
                title={t("send_code" )}
                message={t("send_code_confirmation")}
                onConfirm={async () => {	
                    setLoadingSendSMS(true)
                    try {
                        const res=await sendSMSMiseADispo({ "numero": watch('téléphone_destinataire'),"placeId":place._id,"method":"sms"},token)
                        toast.success(res.message, {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        })
                    } catch (error) {
                        toast.error(t("transfer_request_err"), {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        })
                    }finally {
                        setModalIsOpenSendSMS(false)
                        setLoadingSendSMS(false)
                    }
                }}
                            
                onCancel={()=>{
                    setModalIsOpenSendSMS(false)
                }}
                isLoading={loadingSendSMS}
            />
             <ActionModal
                isOpen={modalIsOpenSendEmail}
                onRequestClose={()=>{}}
                title={t("send_code" )}
                message={t("send_code_confirmation")}
                onConfirm={async () => {	     
                    setLoadingSendSMS(true)
                    try {
                        const res=await sendSMSMiseADispo({ "email": watch('email_destinataire'),"placeId":place._id,"method":"email"},token)
                        toast.success(res.message, {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        })
                    } catch (error) {
                        toast.error(t("transfer_request_err"), {
                            style: {
                                fontFamily: 'Montserrat',
                            },
                        })
                    }finally {
                        setModalIsOpenSendEmail(false)
                        setLoadingSendSMS(false)
                    }
                    }}
                            
                onCancel={()=>{
                    setModalIsOpenSendEmail(false)
                }}
                isLoading={loadingSendSMS}
            />
           
           <Modal
                isOpen={modalIsOpenDelete}
                style={{
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.45)',
                    },
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        borderRadius: 19,
                        padding: '2rem',
                    },
                }}
                contentLabel='Example Modal'
            >
                <div
                    style={{
                        width: '20rem',
                        fontFamily: 'Montserrat',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 15,
                        textAlign: 'center',
                    }}
                >
                    <div
                    style={{
                        fontWeight: 'bold',
                        fontFamily: 'Montserrat',
                        fontSize:20,
                        color: '#51C7F2',
                    }}
                    > {t("delete_address")}</div>
                    <div
                        style={{
                            marginTop: 4,
                            width: '100%',
                        }}
                    >
                        
                        <p>{t("delete_address_err")}</p>
    
                    </div>
                     <div
                     style={{
                        width: '100%',
                        fontFamily: 'Montserrat',
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                        marginBottom: '5px',
                        marginTop: '1rem',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                    <button
                    
                        onClick={async () => {
                                setLoading(true)
                                try {
                                    await softDeleteWaypoint(token,selectedPlace)
                                    setChargement(true)
                                } catch (error) {
                                    toast.error(t("transfer_request_err"), {
                                        style: {
                                            fontFamily: 'Montserrat',
                                        },
                                    });
                                }finally{
                                    setModalIsOpenDelete(false)
                                    setSelectedPlace(null)
                                    setLoading(false)

                                }
                            }}
                        disabled={loading}
                        style={{
                            width:"150px",
                            height:"50px",
                            background: '#50F5A9',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'white',
                            borderRadius: 7,
                            marginTop: 5,
                            fontFamily: 'Montserrat',
                            marginRight:10,
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}

                    >
                    
                    {loading ? (
                                    <div className='loader'></div>
                                ) : (
                                    t("confirm")
                                )}
                                
                    </button>
                    <button
                        onClick={ () => {
                            setModalIsOpenDelete(false)
                                                
                        }}
                        style={{
                            width:"150px",
                            height:"50px",
                            background: 'red',
                            border: 'none',
                            cursor: 'pointer',
                            color: 'white',
                            borderRadius: 7,
                            marginTop: 5,
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                        }}
                    >
                        {t("cancel")}
                    </button>
                    </div>
                    
                </div>
           </Modal>
        </div>
    );
}

export default WaypointManagementCard;
